import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataEmailLog(params) {
	return client.get("api/email-log/data-ecommerce", {
		params: params,
	});
}

export default {
	getDataEmailLog
};